import { gql, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import * as React from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import { Loading } from '@/imports/ui/chakra/components/Loading';
import { UnexpectedError } from '@/imports/ui/chakra/components/UnexpectedError';
import { NotAllowedToViewContent } from '@/imports/ui/pages/group/NotAllowedToViewContent';

import {
  GroupActivityPane_groupQuery,
  GroupActivityPane_groupQueryVariables,
} from './graphql-types/GroupActivityPane_groupQuery';

import { GroupPageLayout } from '../GroupPageLayout';
import { GroupActivityPaneContent } from './components';

const GROUP_QUERY = gql`
  query GroupActivityPane_groupQuery($input: GroupInput!) {
    group(input: $input) {
      result {
        _id
        name
        currentUserGroupPermission {
          canViewContent
        }
        currentUserGroupLink {
          _id
        }
      }
    }
  }
`;

export const GroupActivityPane: React.FC = (props) => {
  const router = useRouter();
  const { groupId } = router.query;
  const permissions = usePermissions();

  const { loading, error, data } = useQuery<
    GroupActivityPane_groupQuery,
    GroupActivityPane_groupQueryVariables
  >(GROUP_QUERY, {
    variables: {
      input: {
        _id: groupId.toString(),
      },
    },
  });

  const group = data?.group.result;
  const canCreatePostInGroup =
    !!group?.currentUserGroupLink?._id ||
    permissions.canDoAdminStuffAndAuthenticated;

  return (
    <GroupPageLayout>
      {loading ? (
        <Loading />
      ) : error ? (
        <UnexpectedError />
      ) : !group ? (
        <UnexpectedError />
      ) : !group.currentUserGroupPermission?.canViewContent ? (
        <NotAllowedToViewContent />
      ) : (
        <GroupActivityPaneContent
          groupId={groupId.toString()}
          groupName={group.name}
          canCreatePostInGroup={canCreatePostInGroup}
        />
      )}
    </GroupPageLayout>
  );
};
